export const SIZES = 'sizes';
export const BRANDS = 'brands';
export const COLORS = 'colors';
export const PATTERNS = 'patterns';
export const MIN_PRICE = 'minPrice';
export const MAX_PRICE = 'maxPrice';
export const PRICE_TYPES = 'priceTypes';
export const STYLES = 'styles';
export const CONTEXTS = 'contexts';
export const OCCASIONS = 'occasion';
export const AVAILABILITY = 'availability';
export const DESIGNER = 'designer';
export const PRICE = 'price';
export const IN_STORE = 'inStore';
export const BACK_ORDER = 'BACK_ORDER';
export const PRE_ORDER = 'PRE_ORDER';

export const INIT_FILTERS = {
  text: '',
  brands: '',
  sizes: '',
  colors: '',
  minPrice: '',
  maxPrice: '',
  priceTypes: '',
  patterns: '',
  styles: '',
  contexts: '',
  availability: '',
  inStore: '',
  sortBy: '',
  sortDirection: '',
};

export const priceTypesLabels = {
  REGULAR: 'Full price',
  ON_SALE: 'Sale',
  ON_PROMOTION: 'Promo',
};
